const LOCAL_STORAGE_KEY = 'recentlyVisited';

const EMPTY_VALUE = {
  products: [],
};

const withLocalStorage = cb => {
  try {
    if (IS_SERVER || !window.localStorage) {
      // There is no localStorage on the server, and localStorage can be null if
      // disabled in the browser.
      return null;
    }
    return cb(window.localStorage);
  } catch (e) {
    // localStorage may throw an exception when disabled; just ignore it.
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Error occurred in withLocalStorage:', e);
    }
  }
  return null;
};

export const readRecentlyVisited = () => {
  const jsonString = withLocalStorage(localStorage =>
    localStorage.getItem(LOCAL_STORAGE_KEY)
  );
  if (!jsonString) {
    return EMPTY_VALUE;
  }

  try {
    const data = JSON.parse(jsonString);
    return data !== null && typeof data === 'object' ? data : EMPTY_VALUE;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Could not parse recent visits from localStorage:', e);
    }
    return EMPTY_VALUE;
  }
};

export const writeRecentlyVisited = data => {
  const jsonString = JSON.stringify(data);
  withLocalStorage(localStorage => {
    localStorage.setItem(LOCAL_STORAGE_KEY, jsonString);
  });
};

export const deleteRecentlyVisited = () => {
  withLocalStorage(localStorage => {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  });
};
